<template>
  <div>
    <div class="modal_inputs" v-if="content">
      <p class="text-gray-700">{{ content }}</p>
    </div>
    <div class="modal_actions">
      <Button
        v-if="showCancel"
        secondary-button
        :text="cancelText"
        type="button"
        @click="handleCancel"
      />
      <Button v-if="showConfirm" :text="confirmText" type="button" @click="handleConfirm" />
    </div>
  </div>
</template>

<script setup>
import Button from "@/components/UI/Form/Button/Button.vue";
import { useModal } from "@/components/UI/Modal/useModal";

const props = defineProps({
  title: {
    type: String,
    default: "Confirm",
  },
  content: {
    type: String,
    default: "",
  },
  showConfirm: {
    type: Boolean,
    default: true,
  },
  showCancel: {
    type: Boolean,
    default: true,
  },
  confirmText: {
    type: String,
    default: "Confirm",
  },
  cancelText: {
    type: String,
    default: "Cancel",
  },
  onConfirm: {
    type: Function,
    default: () => {},
  },
  onCancel: {
    type: Function,
    default: () => {},
  },
});

const { close } = useModal();

const handleConfirm = () => {
  if (props.onConfirm) {
    props.onConfirm();
  } else {
    close(true);
  }
};

const handleCancel = () => {
  if (props.onCancel) {
    props.onCancel();
  } else {
    close(false);
  }
};
</script>
